const createPropertyName = id => `input_${id}`

export default createPropertyName
